import {Box, Typography} from '@mui/material';
import {ChipPropsType} from '../types';
import {Image} from '@jobseeker/lotus/components/Image';
import {useIsLargeDevice, useWrappedTheme} from '@jobseeker/lotus/hooks';
import {CrossOutlineWhite, AddOutlineBlack} from '../../../assets/icons';

export default ({
  selectedChips,
  setSelectedChips,
  chipPrimaryColor,
  chipsData,
}: ChipPropsType) => {
  const theme = useWrappedTheme();
  const isLargeDevice = useIsLargeDevice();

  const handleChipClick = (chipValue: string) => {
    if (selectedChips && setSelectedChips) {
      setSelectedChips(
        selectedChips.includes(chipValue)
          ? selectedChips.filter(chip => chip !== chipValue)
          : [...selectedChips, chipValue]
      );
    }
  };

  return (
    <Box
      display={chipsData?.length ? 'flex' : 'none'}
      flexWrap={'wrap'}
      alignItems={'center'}
      justifyContent={'flex-start'}
      gap={isLargeDevice ? 1 : 0.5}
    >
      {chipsData?.map((chipValue: string) => {
        const chipSelected = selectedChips?.includes(chipValue);
        return (
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'flex-start'}
            gap={0.5}
            py={0.5}
            px={isLargeDevice ? 1 : 0.5}
            borderRadius={1.5}
            bgcolor={chipSelected ? chipPrimaryColor : '#ffffff'}
            height={'26px'}
            border={'0.74px solid #ffffff'}
            sx={{
              cursor: 'pointer',
            }}
            onClick={() => {
              handleChipClick(chipValue);
            }}
          >
            <Typography
              fontSize={
                isLargeDevice
                  ? theme.typography.pxToRem(12)
                  : theme.typography.pxToRem(10)
              }
              fontWeight={500}
              component={'span'}
              lineHeight={isLargeDevice ? '18px' : '15px'}
              color={chipSelected ? '#ffffff' : 'secondary.main'}
              whiteSpace={'nowrap'}
            >
              {chipValue}
            </Typography>
            <Image
              src={chipSelected ? CrossOutlineWhite : AddOutlineBlack}
              alt=""
              width={12}
              height={12}
              style={{
                cursor: 'pointer',
              }}
            />
          </Box>
        );
      })}
    </Box>
  );
};
